module.exports = __webpack_public_path__ + "img/5.36fa6292.jpg";